import React, { Component } from 'react'
import $ from 'jquery'
import { AppSettings, MessageText, Storage } from '../../configs'

import {
    SecureGateRoute,
    BreadCrumb,
    DepartmentMapModal
} from "../../components"

import { connect } from 'react-redux'
import { Select } from "../../components/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { msg } from '../../components/Notifications/MsgBox';

import '../../assets/css/rrs.css'
import { getAllOrgUnitsAction } from '../../redux/actions/MasterAction'
import {
    getAllDepartmentMapAction,
    updatedepartmentMapModalAction,
    deleteDepartmentMapAction,
    getAllUnitReviewerAction
} from '../../redux/actions/DepartmentMapAction'
import UserServices from '../../services/UserServices';


class DepartmentScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            order_user: "asc",
            orderBy_user: "",
            page_user: 0,
            rowsPerPage_user: 10,
            filterdepartmapArr: [],
            create_Department: '',
            filter_reviewer_Department: '',
            setArrOrgUnits: [],
            setArrUnitReviewer: [],
            appReadonly: true
        }

        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.deleteDepartMap = this.deleteDepartMap.bind(this)
        this.loadDataDapartmentAll = this.loadDataDapartmentAll.bind(this)
        this.setDefaultPage = this.setDefaultPage.bind(this)
        this.handleChangefilter = this.handleChangefilter.bind(this)
        window.onSavePopupDepartmentMap = this.loadDataDapartmentAll.bind(this)
    }

    componentDidMount() {
        this.loadDataDapartmentAll()
        $(function () {
            window.onComponentDidMount()
        })
    }

    async loadDataDapartmentAll() {
        const employeePIS = Storage.getEmployeePIS()
        console.log("employeePIS")
        console.log(employeePIS)

        await this.props.getAllOrgUnits()
        await this.props.getAllDepartmentMap()

        if (typeof employeePIS.departmentCode != "undefined" && employeePIS.departmentCode != null && employeePIS.departmentCode) {
            await this.props.getAllUnitReviewer(employeePIS.departmentCode ? employeePIS.departmentCode : '00000000')
        }

        this.filterdata()

        this.handleApplicationCheckReadonly()
    }

    setDefaultPage() {
        this.setState({
            page_user: 0
        })
    }

    async handleApplicationCheckReadonly()
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                this.setState({appReadonly: false})
            }
        })
    }
    

    componentWillReceiveProps(nextProps) {
        if (nextProps.departmapAll !== this.state.filterdepartmapArr) {

            const employeePIS = Storage.getEmployeePIS()
            let department = []
            if (typeof employeePIS.departmentCode != "undefined" && employeePIS.departmentCode != null && employeePIS.departmentCode)
                department = nextProps.departmapAll.filter(f => f.reviewer_Department == employeePIS.departmentCode)
            else
                department = nextProps.departmapAll

            this.setState({
                filterdepartmapArr: department
            })

        }
    }

    setDepartMapModal(index = "") {

        let data = { index: index }
        this.props.updatedepartmentMapModal(data)
    }

    deleteDepartMap(departmapId) {
        const { departmapAll } = this.props
        let objdepartment = departmapAll.find(f => f.map_ID == departmapId)

        if (objdepartment) {
            msg.showConfirm("Confirm",
                MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_CONFIRM_DELETE,
                async () => {
                    msg.hideConfirm()
                    await this.props.deleteDepartmentMap(objdepartment)
                    if (this.props.isSuccess) {
                        msg.success(MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_SUCCESS_DELETE)
                        this.loadDataDapartmentAll()
                        
                    } else {
                        msg.error(this.props.departmaperrorMsg)
                    }
                },
                () => {
                    msg.hideConfirm()
                    console.log("On Cancel")
                },
                () => {
                    console.log("On Closed")
                }
            )
        }

    }

    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy_user === property && this.state.order_user === "desc";
        this.setState({
            order_user: isDesc ? "asc" : "desc",
            orderBy_user: property
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page_user: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage_user: +event.target.value,
            page_user: 0
        })
    }

    async handleChangefilter(event) {
        event.preventDefault()
        const { name, value } = event.target;

        await this.setState({ [name]: value })
        this.filterdata()
    }

    async filterdata() {

        let filterDepartMap = []
        const employeePIS = Storage.getEmployeePIS()
        if (typeof employeePIS.departmentCode != "undefined" && employeePIS.departmentCode != null && employeePIS.departmentCode) {
            filterDepartMap = this.props.departmapAll.filter(f => f.reviewer_Department == employeePIS.departmentCode)
        }
        else{
            filterDepartMap = this.props.departmapAll
        }

        if (this.state.filter_create_Department) {
            filterDepartMap = filterDepartMap.filter((data) => {
                return data.create_Department && (data.create_Department.indexOf(this.state.filter_create_Department) > -1 || data.create_Department_Name.indexOf(this.state.filter_create_Department) > -1)
            })
        }
        if (this.state.filter_reviewer_Department) {
            filterDepartMap = filterDepartMap.filter((data) => {
                return data.reviewer_Department && (data.reviewer_Department.indexOf(this.state.filter_reviewer_Department) > -1 || data.reviewer_Department_Name.indexOf(this.state.filter_reviewer_Department) > -1)
            })
        }
        if (this.state.filter_status && this.state.filter_status == 1) {
            filterDepartMap = filterDepartMap.filter((data) => {
                return data.isActive == true
            })
        }
        if (this.state.filter_status && this.state.filter_status == 2) {
            filterDepartMap = filterDepartMap.filter((data) => {
                return data.isActive == false
            })
        }

        await this.setState({ filterdepartmapArr: filterDepartMap })
        this.setDefaultPage()
    }


    // Grid end

    render() {
        const { departmapAll } = this.props
        const { filter_reviewer_Department, filter_create_Department, filter_status, filterdepartmapArr, appReadonly } = this.state;
        const roleAdmin = Storage.getRoleAdmin()
        // console.log("departmapAll")
        // console.log(departmapAll)

        return (
            <div className="rrs">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'Department Mapping', url: '' }
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Department Mapping </h1>
                            </div>
                        </div>
                        <div className="sp-page-result-container" style={{ marginTop: 18 }} id="user" >
                            <div className="sp-table-container">
                                <div className="row rrs-table-hdr-wrap">
                                    {/* <div className="col-md-2">
                                        <h2 className="rrs-table-hdr">หน่วยงานผู้ใช้</h2>
                                    </div> */}
                                </div>
                                {roleAdmin && !appReadonly && (
                                    <div className="row sp-pagination-control-top">
                                        <div className="col-auto create-button" >
                                            <a href="#" className="sp-bt-addmore" onClick={() => this.setDepartMapModal()} data-toggle="modal" data-target="#departmentMap">
                                                <i className="icon btn-plus" />
                                                <span>เพิ่ม</span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters sp-table-content">
                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center" style={{ width: '400px', maxWidth: '400px' }}>หน่วยงานผู้สร้างข้อมูล (Creator)</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '380px', maxWidth: '380px' }}>หน่วยงานจัดหา (Reviewer)</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '120px' }}>สถานะ</TableCell>
                                                { !appReadonly && <TableCell className="th-table text-center" style={{ width: '20px', maxWidth: '20px' }}>Edit</TableCell>}
                                                { !appReadonly && <TableCell className="th-table text-center" style={{ width: '20px', maxWidth: '20px', display: roleAdmin ? "" : "none" }}>ลบ</TableCell>}
                                            </TableRow>
                                            <TableRow className="sp-table-filter">
                                                <TableCell><input type="text" name="filter_create_Department" className="form-control" onChange={this.handleChangefilter} value={filter_create_Department} /></TableCell>
                                                <TableCell><input type="text" name="filter_reviewer_Department" className="form-control" onChange={this.handleChangefilter} value={filter_reviewer_Department} /></TableCell>
                                                <TableCell>
                                                    <Select
                                                        name="filter_status"
                                                        value={filter_status}
                                                        onChange={this.handleChangefilter}
                                                    >
                                                        <option
                                                            key={0}
                                                            value={0}>
                                                            {"เลือกทั้งหมด"}
                                                        </option>
                                                        <option
                                                            key={1}
                                                            value={1}>
                                                            {"ใช้งาน"}
                                                        </option>
                                                        <option
                                                            key={2}
                                                            value={2}>
                                                            {"ไม่ใช้งาน"}
                                                        </option>
                                                    </Select>
                                                </TableCell>
                                                {/* <TableCell></TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(filterdepartmapArr) && (this.stableSort(filterdepartmapArr, this.getSorting(this.state.order_user, this.state.orderBy_user))
                                                .slice(this.state.page_user * this.state.rowsPerPage_user, this.state.page_user * this.state.rowsPerPage_user + this.state.rowsPerPage_user)
                                                .map((row, index) => {

                                                    let index_start = departmapAll.findIndex(f => f.map_ID == row.map_ID)

                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            <TableCell><label className="label-full text-grid">{row.create_Department + ' : ' + row.create_Department_Name}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.reviewer_Department + ' : ' + row.reviewer_Department_Name}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.isActive ? "ใช้งาน" : "ไม่ใช้งาน"}</label></TableCell>
                                                            { !appReadonly && <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setDepartMapModal(index_start)} data-toggle="modal" data-target="#departmentMap">
                                                                    <i className="icon bt-edit" />
                                                                </a>
                                                            </TableCell>}
                                                            { !appReadonly &&  <TableCell className="action-icon" style={{ display: roleAdmin ? "" : "none" }}>
                                                                <button className="btn" onClick={() => { this.deleteDepartMap(row.map_ID) }}>
                                                                    <i className="icon btn-trash" />
                                                                </button>
                                                            </TableCell>}
                                                        </TableRow>
                                                    );

                                                }))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={this.state.filterdepartmapArr.length}
                                        rowsPerPage={this.state.rowsPerPage_user}
                                        page={this.state.page_user}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DepartmentMapModal />

                {/* backtotop button */}
                <div className="backtotop-panel">
                    <span className="bt-backtotop btn">
                        <i className="icon btn-order-top" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })} />
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MasterRedux, DepartmentMapRedux } = state
    return {
        org_unit: MasterRedux.org_unit,
        departmapAll: DepartmentMapRedux.departmapAll,
        isSuccess: DepartmentMapRedux.isSuccess,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
        getAllDepartmentMap: () => dispatch(getAllDepartmentMapAction()),
        getAllUnitReviewer: (data) => dispatch(getAllUnitReviewerAction(data)),
        updatedepartmentMapModal: (data) => dispatch(updatedepartmentMapModalAction(data)),
        deleteDepartmentMap: (data) => dispatch(deleteDepartmentMapAction(data)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartmentScreen);